import React from "react"
import { Layout } from "../components/layout";
import { useTranslation } from "react-i18next";
import { useConfiguration } from "../hooks/useConfiguration";
import { Address } from "../elements/imprint/address";
import { ContactsList } from "../elements/imprint/contactsList";
import { Disclaimer } from "../elements/imprint/disclaimer";

export const Imprint = () => {
    const configuration = useConfiguration();

    const { t, i18n } = useTranslation();

    if (configuration === undefined) {
      return null;
    }

  const { copyright, region } = configuration;
  const footerLink = `/privacy/${i18n.language}`;
  return (
    <Layout copyright={copyright} footerLink={footerLink} footerLinkTitle={t('imprint.footer.dataPrivacyLink')}>
      <section className='profile'>
        <div className='content'>
          <div className='row'>
            <div className='col-9'>
              <h1 className='profile__title'>{t('imprint.title')}</h1>
            </div>
          </div>

          <div className='text'>
            <Address region={region} />

            <ContactsList region={region} />
            <hr />

            <Disclaimer region={region}/>
          </div>
        </div>
        <div className='clear-footer'></div>
      </section>
    </Layout>
  );
}